export default "__VITE_ASSET__Br2$050B__"